import { apiGet, apiPatch, apiPost, apiPut, apiDelete } from './api';
import { 
  URL_DRINK, URL_DRINK_BY_ID, URL_COMMANDE, URL_DRINK_BY_SEANCE,
  URL_PRICE_HISTORY_ANONYMOUS_BY_DRINK,
  URL_DRINK_ANONYMOUS_SORTED_BY_CAT_BY_SEANCE, URL_PRICE_HISTORY_ANONYMOUS_BY_SEANCE,
  URL_CATEGORY, URL_DRINK_ANONYMOUS
} from './urls';

export async function getAllDrinks() {
  const response = await apiGet(URL_DRINK);
  return response;
}
export async function getAllDrinksBySeance(id) {
  const response = await apiGet(URL_DRINK_BY_SEANCE(id));
  return response;
}
export async function getAllDrinksAnonymousByCatBySeance(id) {
  const response = await apiGet(URL_DRINK_ANONYMOUS_SORTED_BY_CAT_BY_SEANCE(id), false);
  return response;
}
export async function getPriceHistoriesAnonymousBySeance(id) {
  const response = await apiGet(URL_PRICE_HISTORY_ANONYMOUS_BY_SEANCE(id), false);
  return response;
}
export async function getPriceHistoriesAnonymousByDrink(id) {
  const response = await apiGet(URL_PRICE_HISTORY_ANONYMOUS_BY_DRINK(id), false);
  return response
}
export async function getAnonymousDataForDrink(seance_id, drink_id) {
  return await apiGet(URL_DRINK_ANONYMOUS(seance_id, drink_id), false)
}
export async function createDrink(drink) {
    const response = await apiPost(URL_DRINK, drink);
    return response;
}
export async function getDrinkById(id) {
  const response = await apiGet(URL_DRINK_BY_ID(id));
  return response;
}
export async function updateDrink(drink) {
  const response = await apiPut(URL_DRINK_BY_ID(drink.id), drink);
  return response;
}
export async function deleteDrink(drink) {
  const response = await apiDelete(URL_DRINK_BY_ID(drink.id));
  return response;
}
export async function createCommande(commande) {
  const resp = await apiPost(URL_COMMANDE, commande)
  return resp;
}

export async function getCategories(){
  const rep = await apiGet(URL_CATEGORY)
  return rep
}